import API from './api';

export const {
  AccessHistoryApi,
  AffiliateFeedApi,
  AffiliateTagApi,
  AppConfigApi,
  BankApi,
  CategoryApi,
  CategoryGroupApi,
  ChatbotStepApi,
  CountryApi,
  CurrencyApi,
  FaqFeedApi,
  NotificationApi,
  PopupFeedApi,
  TimezoneApi,
  TrafficTypeApi,
} = API.getShared();

export { API };
export { default as AffiliateApi } from './AffiliateApi';
export { default as AffiliateMarketplaceInviteApi } from './AffiliateMarketplaceInviteApi';
export { default as AffiliateStatApi } from './AffiliateStatApi';
export { default as AffiliateUserApi } from './AffiliateUserApi';
export { default as ApiKeyApi } from './ApiKeyApi';
export { default as BalanceApi } from './BalanceApi';
export { default as CampaignApi } from './CampaignApi';
export { default as ContactApi } from './ContactApi';
export { default as ClientApiApi } from './ClientApiApi';
export { default as DashboardApi } from './DashboardApi';
export { default as DownloadApi } from './DownloadApi';
export { default as EasyStoreSetupApi } from './EasyStoreSetupApi';
export { default as EmailTemplateApi } from './EmailTemplateApi';
export { default as ImageCreativeApi } from './ImageCreativeApi';
export { default as MissingOrderApi } from './MissingOrderApi';
export { default as MktSiteApi } from './MktSiteApi';
export { default as NetworkUserApi } from './NetworkUserApi';
export { default as NetworkAffiliatePreferenceApi } from './NetworkAffiliatePreferenceApi';
export { default as OfferApi } from './OfferApi';
export { default as OrderApi } from './OrderApi';
export { default as PasswordApi } from './PasswordApi';
export { default as ProductApi } from './ProductApi';
export { default as ReportApi } from './ReportApi';
export { default as SearchKeyApi } from './SearchKeyApi';
export { default as SiteInfoApi } from './SiteInfoApi';
export { default as TextCreativeApi } from './TextCreativeApi';
export { default as UploadApi } from './UploadApi';
export { default as UserApi } from './UserApi';
export { default as UserPasswordApi } from './UserPasswordApi';
